<template>
  <div class="m-grid m-grid--hor m-grid--root m-page">
    <AppHeader/>
    <!-- begin::Body -->
    <div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
      <LeftMenu/>
      <div class="m-grid__item m-grid__item--fluid m-wrapper">
        <div class="m-content">
          <Stats/>
          <div class="row">
            <Services />
            <Properties />
          </div>
        </div>
      </div>
    </div>
    <AppFooter/>
  </div>
</template>

<script>
  import AppHeader from '@/components/dashboard/common/Header';
  import AppFooter from '@/components/dashboard/common/Footer';
  import LeftMenu from '@/components/dashboard/common/menus/LeftMenu';

  import Stats from '@/components/dashboard/stats/Stats'
  import Services from '@/components/dashboard/stats/Services'
  import Properties from '@/components/dashboard/stats/Properties'

  export default {
    name:'Dashboard',
    data() {
      return {}
    },
    computed: {
    },
    components: {
      AppFooter,
      AppHeader,
      LeftMenu,
      Stats,
      Services,
      Properties
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/dashboard/HomePage.vue